'use client';

import type { ReactNode } from 'react';
import { UpdateSignalEditModalWrapper } from '../../HITL/wrappers/UpdateSignalEditModalWrapper';
import type { EditModalProps } from '../../tool-config-types';

export const renderUpdateSignalEditModal = (
  props: EditModalProps,
): ReactNode => (
  <UpdateSignalEditModalWrapper
    isOpen={props.isOpen}
    onClose={props.onClose}
    onSubmit={props.onSubmit}
    toolName={props.toolName}
    extractedData={props.extractedData}
  />
);
